<template>
  <v-dialog v-model="isOpen" max-width="500px" persistent>
    <v-card color="black-card" class="login-modal">
      <v-card-title class="text-h5 pa-6 d-flex justify-space-between align-center">
        <span class="text-white">로그인</span>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click="closeModal"
          size="small"
        ></v-btn>
      </v-card-title>

      <v-card-text class="pa-6">
        <!-- 소셜 로그인 버튼들 -->
        <SocialLogin @success="handleLoginSuccess" />

        <v-divider class="my-6">
          <span class="px-4 text-caption text-gray-dark">또는</span>
        </v-divider>

        <!-- 이메일 로그인 폼 -->
        <v-form @submit.prevent="handleEmailLogin">
          <v-text-field
            v-model="email"
            label="이메일"
            type="email"
            variant="outlined"
            prepend-inner-icon="mdi-email"
            color="primary"
            required
            dark
          ></v-text-field>

          <v-text-field
            v-model="password"
            label="비밀번호"
            :type="showPassword ? 'text' : 'password'"
            variant="outlined"
            prepend-inner-icon="mdi-lock"
            :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append-inner="showPassword = !showPassword"
            color="primary"
            required
            dark
          ></v-text-field>

          <v-alert v-if="error" type="error" class="mb-4" variant="tonal">
            {{ error }}
          </v-alert>

          <v-btn
            type="submit"
            color="primary"
            block
            size="large"
            :loading="loading"
            class="mb-4"
          >
            로그인
          </v-btn>
        </v-form>

        <div class="text-center">
          <v-btn
            @click="switchToSignup"
            variant="text"
            color="primary"
            size="small"
          >
            계정이 없으신가요? 회원가입
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import SocialLogin from './SocialLogin.vue'

const props = defineProps({
  modelValue: Boolean
})

const emit = defineEmits(['update:modelValue', 'switch-to-signup'])

const router = useRouter()
const route = useRoute()

const email = ref('')
const password = ref('')
const showPassword = ref(false)
const loading = ref(false)
const error = ref(null)

const isOpen = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const handleEmailLogin = () => {
  loading.value = true
  error.value = null

  // 임시 로그인 로직 (Firebase 연동 전)
  setTimeout(() => {
    if (email.value && password.value) {
      console.log('로그인 시도:', email.value)
      handleLoginSuccess()
    } else {
      error.value = '이메일과 비밀번호를 입력해주세요.'
    }
    loading.value = false
  }, 1000)
}

const handleLoginSuccess = () => {
  isOpen.value = false
  const redirectPath = route.query.redirect || '/classroom'
  router.push(redirectPath)
}

const closeModal = () => {
  isOpen.value = false
  email.value = ''
  password.value = ''
  error.value = null
}

const switchToSignup = () => {
  isOpen.value = false
  emit('switch-to-signup')
}
</script>

<style scoped>
.login-modal {
  border: 2px solid var(--mocha-mousse);
}

.v-card-title {
  border-bottom: 1px solid rgba(164, 120, 100, 0.2);
}
</style>
